export type AppType = "MIGRATOR" | "SUPPORT_ASSISTED" | "CUSTOMER_FACING"
export function useAppType(): AppType {
    let hash = window.location.hash
    if(hash.startsWith("#")) hash = hash.substring(1)
    if(hash === "mig") return "MIGRATOR"
    if(hash === "cf") return "CUSTOMER_FACING"
    return "SUPPORT_ASSISTED"
}